import { render, staticRenderFns } from "./LifePage1.vue?vue&type=template&id=5115836c&scoped=true"
import script from "./LifePage1.vue?vue&type=script&lang=js"
export * from "./LifePage1.vue?vue&type=script&lang=js"
import style0 from "./LifePage1.vue?vue&type=style&index=0&id=5115836c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115836c",
  null
  
)

export default component.exports